import React, { useState, useEffect } from "react";
import { IconButton, Menu, MenuItem, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import LanguageIcon from "@mui/icons-material/Language";
import moment from "moment";

const options = [
    { name: "العربية", key: "ar" },
    { name: "Türkçe", key: "tr-TR" },
    { name: "English", key: "en-US" },
    { name: "Pусский", key: "ru-RU" },
    { name: "Română", key: "ro-RO" },
    { name: "Thai", key: "th-TH" },
    { name: "Italian", key: "it-IT" },
    { name: "Polish", key: "pl-PL" },
    { name: "Slovak", key: "sk-SK" },
];

const SelectLanguage = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { t } = useTranslation("translation");
    const { i18n } = useTranslation();
    const [selectedIndex, setSelectedIndex] = useState(options.findIndex((lang) => lang.key === i18n.language));
    const [renderMobileScreen, setRenderMobileScreen] = useState(false);

    const HandleMenuItemClick = (_event, index) => {
        setSelectedIndex(index);
        i18n.changeLanguage(options[index].key);
        moment.locale(options[index].key);
        setAnchorEl(null);
        refreshPage();
    };

    useEffect(() => {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
            setRenderMobileScreen(true);
        } else {
            setRenderMobileScreen(false);
        }
    }, [window.navigator.userAgent]);

    const refreshPage = () => {
        window.location.reload(true);
    };

    return (
        <div>
            <Tooltip id="sela_Tooltip" title={t("Language")}>
                <IconButton id="sela_IconButton" aria-label="language-select" color="inherit" onClick={(event) => setAnchorEl(event.currentTarget)} size="large">
                    <LanguageIcon id="sela_LanIcon" />
                    {renderMobileScreen ? <Typography style={{ marginLeft: "10px" }}>{t("Language")}</Typography> : null}
                </IconButton>
            </Tooltip>
            <Menu id="lock-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                {options.map((option, index) => (
                    <MenuItem id={`sela_MItem_${index}`} key={index} selected={index === selectedIndex} onClick={(event) => HandleMenuItemClick(event, index)}>
                        {option.name}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
};

export default SelectLanguage;
